export default __webpack_public_path__ + "static/media/room-rent.2ca6ecd6.svg";